// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"cf1e67d4","144":"3cc5ebef","174":"e53af961","199":"1e38553f","226":"9fc0e16a","337":"30a4c572","350":"fdca3a5c","411":"52c66f09","547":"de54e23e","649":"8a3caaf7","911":"2b03e7b4"}[chunkId] + ".chunk.js";
};